import $ from 'jquery';

$(() => {
    const $modal = $('#filterModal');

    $modal.get(0).addEventListener('fds.modal.hidden', () => {
        $modal.closest('form').submit();
    });
    $('#filterModalReset').on('click', () => {
        $modal.find('select, input').val('');
    })
});
